//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GridCardComponent from '@/components/work_environments/GridCardComponent';
export default {
  name: 'Somos1ReportsHome',
  components: {
    GridCardComponent: GridCardComponent
  },
  data: function data() {
    return {
      cards: [{
        title_es: 'Insights',
        title_en: 'Insights',
        subtitle_es: 'Reportes con KPIs principales sobre el performance de las empresas del grupo Intercorp a nivel zonal e interzonal.',
        subtitle_en: 'Reports with main KPIs on the performance of the companies of the Intercorp group at zonal and interzonal level.',
        flex: 4,
        color: '#F1F1F1',
        image: 'Insights.png',
        path: '/customer_insights/somos1/reports',
        access: false
      }, {
        title_es: 'Presentación para visitas',
        title_en: 'Presentation for visitors',
        subtitle_es: 'Reportes Somos 1 con KPIs principales (financieros y operacionales) de las regiones con presencia del grupo Intercorp.',
        subtitle_en: 'Somos 1 reports with main KPIs (financial and operational) of the regions with presence of the Intercorp group.',
        flex: 4,
        color: '#F1F1F1',
        image: 'Presentation.png',
        path: '/customer_insights/visitor_presentation',
        access: true
      }, {
        title_es: 'Métricas de uso',
        title_en: 'Usage Metrics',
        subtitle_es: 'Reportes con KPIs principales sobre la adopción y uso de los reportes Somos 1.',
        subtitle_en: 'Reports with main KPIs on the adoption and use of Somos 1 reports.',
        flex: 4,
        color: '#F1F1F1',
        image: 'Metricas.png',
        path: '/customer_insights/metricas/reports',
        access: true
      }],
      filter_enabled: true
    };
  },
  methods: {
    setAccess: function setAccess() {
      this.cards[0].access = !!(this.userHasRole(this.rolesINCA.INSIGHTS_ADMIN) || this.userHasRole(this.rolesINCA.INSIGHTS_USER_SOMOS1) || this.userHasRole(this.rolesINCA.INSIGHTS_BUSINESS_USER) || this.userHasRole(this.rolesINCA.INSIGHTS_SOMOS1_CORP_VIEWER) || this.userHasRole(this.rolesINCA.ORG_DATA_STEWARD));
      this.cards[1].access = !!(this.userHasRole(this.rolesINCA.INSIGHTS_ADMIN) || this.userHasRole(this.rolesINCA.INSIGHTS_USER_SOMOS1) || this.userHasRole(this.rolesINCA.INSIGHTS_SOMOS1_CORP_VIEWER) || this.userHasRole(this.rolesINCA.ORG_DATA_STEWARD));
      this.cards[2].access = !!(this.userHasRole(this.rolesINCA.INSIGHTS_ADMIN) || this.userHasRole(this.rolesINCA.INSIGHTS_SOMOS1_CORP_VIEWER) || this.userHasRole(this.rolesINCA.ORG_DATA_STEWARD));
    }
  },
  created: function created() {
    this.setAccess();
  },
  computed: {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('menu.customer.home'),
        disabled: false,
        href: '/#/customer_insights/home'
      }, {
        text: this.translate('menu.customer.somos1'),
        disabled: false,
        href: '/#/customer_insights/somos1_home'
      }, {
        text: this.translate('menu.customer.somos1_reports'),
        disabled: true,
        href: ''
      }];
    }
  }
};